import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-487c67e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0 pt-6 p-9\" data-v-487c67e2><div class=\"card-title\" data-v-487c67e2>Requerimientos</div><div class=\"card-toolbar\" data-v-487c67e2><div class=\"d-flex justify-content-end align-items-center d-none\" data-kt-subscription-table-toolbar=\"selected\" data-v-487c67e2><div class=\"fw-bolder me-5\" data-v-487c67e2><span class=\"me-2\" data-kt-subscription-table-select=\"selected_count\" data-v-487c67e2></span> Selected </div><button type=\"button\" class=\"btn btn-danger\" data-kt-subscription-table-select=\"delete_selected\" data-v-487c67e2> Delete Selected </button></div></div></div>", 1)
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = { class: "flex justify-content-end" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_7 = { class: "text-uppercase" }
const _hoisted_8 = { class: "card mb-5 mb-xl-10" }
const _hoisted_9 = { class: "card-body border-top p-9" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Comentario", -1))
const _hoisted_12 = { class: "col-lg-12" }
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Respuesta", -1))
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Fecha Respuesta", -1))
const _hoisted_18 = { class: "col-lg-12 fv-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ExportCustomerModal = _resolveComponent("ExportCustomerModal")!
  const _component_AddCustomerModal = _resolveComponent("AddCustomerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DataTable, {
          value: _ctx.store.getters.allTicketes,
          paginator: true,
          rows: 10,
          showGridlines: "",
          dataKey: "id",
          rowHover: true,
          selection: _ctx.selectedTickets,
          "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTickets) = $event)),
          filters: _ctx.filters1,
          "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters1) = $event)),
          loading: _ctx.loading,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          rowsPerPageOptions: [10, 25, 50],
          currentPageReportTemplate: "Mostrando {first} a {last} de {totalRecords} registros",
          globalFilterFields: [
          'numeroTicket',
          'rutProveedor',
          'contactoEmail',
          'contactoNombre',
          'contactoTelefono',
        ],
          responsiveLayout: "scroll"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.filters1['global'].value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters1['global'].value) = $event)),
                  placeholder: "Buscar"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createTextVNode(" No existen tickets. ")
          ]),
          loading: _withCtx(() => [
            _createTextVNode(" Cargando tickets. Por favor espere. ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "numeroTicket",
              header: "N Ticket",
              sortable: "",
              style: {"min-width":"8rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.numeroTicket), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by name"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "rutProveedor",
              header: "Rut Proveedor",
              sortable: "",
              style: {"min-width":"12rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.rutProveedor), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by name"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "contactoEmail",
              header: "Email",
              sortable: "",
              filterMatchMode: "contains",
              style: {"min-width":"14rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.contactoEmail), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by country"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "contactoNombre",
              header: "Nombre Contacto",
              sortable: "",
              filterMatchMode: "contains",
              style: {"min-width":"18rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.contactoNombre), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by country"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "contactoTelefono",
              header: "Teléfono Contacto",
              sortable: "",
              filterMatchMode: "contains",
              style: {"min-width":"14rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.contactoTelefono), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by country"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "fechaTicket",
              header: "F. Solicitud",
              sortable: "",
              dataType: "date",
              style: {"min-width":"10rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(data.fechaTicket)), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_Calendar, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  dateFormat: "mm/dd/yy",
                  placeholder: "mm/dd/yyyy"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "tipo",
              header: "Tipo Solicitud",
              sortable: "",
              filterMatchMode: "contains",
              style: {"min-width":"12rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(data.tipo), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Buscar por tipo"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "respondido",
              header: "Respondido",
              sortable: "",
              filterMatchMode: "contains",
              style: {"min-width":"14rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["image-text", 'customer-badge status-' + data.respondido])
                }, _toDisplayString(data.respondido ? "Respondido" : "Pendiente"), 3)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by country"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              exportable: false,
              style: {"min-width":"8rem"}
            }, {
              body: _withCtx((slotProps) => [
                (!slotProps.data.respondido)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "pi pi-pencil",
                      class: "p-button-rounded p-button-success mr-2",
                      onClick: ($event: any) => (_ctx.editTicket(slotProps.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (slotProps.data.respondido)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      icon: "pi pi-eye",
                      class: "p-button-rounded p-button-success mr-2",
                      onClick: ($event: any) => (_ctx.verTicket(slotProps.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "selection", "filters", "loading"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: "Observaciones",
      visible: _ctx.display,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.display) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.ticketActual.comentario), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.ticketActual.respuesta), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatDate(_ctx.ticketActual.fechaRespuesta)) + " | " + _toDisplayString(_ctx.ticketActual.usuarioRespuesta), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ExportCustomerModal),
    _createVNode(_component_AddCustomerModal)
  ], 64))
}